export function hasForceHDTag(video) {
  return video?.taxonomy?.tags?.some(x => x.text === "force-hd") || false;
}
